<template>
  <div v-cloak class="Survey-list user-message">
    <div class="titles-right">我的调研</div>
    <div class="ma-tb-10 pa-r-20" v-if="dataList.length != 0">
      <div
        class="b-b-ED flex f-between ma-t-30 pa-b-20 c-pointer"
        v-for="(item, index) in dataList"
        :key="index"
        @click="toDetail(item.Id)"
      >
        <div class="">{{ item.Name }}</div>
        <div class="">{{ item.StartTime }}</div>
      </div>
    </div>
    <div v-if="dataList.length == 0" class="pa-t-100">
      <Empty></Empty>
    </div>
  </div>
</template>
<style lang="scss" spaced>
.Survey-list {
  .titles-right {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
    padding-bottom: 24px;
  }
  .b-b-ED:not(:last-child) {
    border-bottom: 1px solid #ededed;
  }
  .ma-t-60 {
    margin-top: 60px !important;
  }
  .ma-t-10 {
    margin-top: 10px !important;
  }
}
</style>
<script>
import { getSurveyMyList } from "../api.js";
// studycollect
export default {
  name: "Survey-list",
  data() {
    return {
      dataList: {},
      breadList: [{ name: "我的调研", path: "/Survey-list" }],
    };
  },

  created() {
    this.getList();
  },

  // 其他页面进来时更新初始数据
  activated() {
    console.log("909090------");
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },

  methods: {
    getList() {
      let token = localStorage.getItem("AccessToken");
      let data = {
        token: token,
        source: "web",
      };
      getSurveyMyList(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data;
          if (this.dataList.length == 0) {
            this.$router.push({
              path: "/Survey",
            });
          }
        }
      });
    },
    toDetail(id = 0) {
      this.$router.push({
        path: "/Survey-detail-my",
        query: { answerId: id },
      });
    },
  },
};
</script>
